import { getNegBooleans } from '../../utils/getNegBooleans';
import { SpaceContext } from '../types/SpaceContext';

export const prepareInnerContext = (
  prevContext: SpaceContext,
) => {
  // prepare inner context info
  const { outDebt, option, alternative, negBooleans: prevNegBooleans } = prevContext;

  // get neg booleans if undefined
  const negBooleans = prevNegBooleans || getNegBooleans(outDebt, option, alternative);

  const preparedContext = {
    ...prevContext,
    negBooleans,
  };

  return preparedContext;
};
